/* tslint:disable */
/* eslint-disable */
/**
 * Viterbit API
 * This is the documentation for viterbit\'s apps
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FindJobPositionLevelQueryResponse } from './FindJobPositionLevelQueryResponse';
import {
    FindJobPositionLevelQueryResponseFromJSON,
    FindJobPositionLevelQueryResponseFromJSONTyped,
    FindJobPositionLevelQueryResponseToJSON,
} from './FindJobPositionLevelQueryResponse';
import type { ListMeta } from './ListMeta';
import {
    ListMetaFromJSON,
    ListMetaFromJSONTyped,
    ListMetaToJSON,
} from './ListMeta';

/**
 * 
 * @export
 * @interface ListJobPositionLevelQueryResponse
 */
export interface ListJobPositionLevelQueryResponse {
    /**
     * 
     * @type {ListMeta}
     * @memberof ListJobPositionLevelQueryResponse
     */
    meta: ListMeta;
    /**
     * 
     * @type {Array<FindJobPositionLevelQueryResponse>}
     * @memberof ListJobPositionLevelQueryResponse
     */
    data: Array<FindJobPositionLevelQueryResponse>;
}

/**
 * Check if a given object implements the ListJobPositionLevelQueryResponse interface.
 */
export function instanceOfListJobPositionLevelQueryResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "meta" in value;
    isInstance = isInstance && "data" in value;

    return isInstance;
}

export function ListJobPositionLevelQueryResponseFromJSON(json: any): ListJobPositionLevelQueryResponse {
    return ListJobPositionLevelQueryResponseFromJSONTyped(json, false);
}

export function ListJobPositionLevelQueryResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListJobPositionLevelQueryResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'meta': ListMetaFromJSON(json['meta']),
        'data': ((json['data'] as Array<any>).map(FindJobPositionLevelQueryResponseFromJSON)),
    };
}

export function ListJobPositionLevelQueryResponseToJSON(value?: ListJobPositionLevelQueryResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'meta': ListMetaToJSON(value.meta),
        'data': ((value.data as Array<any>).map(FindJobPositionLevelQueryResponseToJSON)),
    };
}

